















import Repair from "./repair.vue"
import Maintenance from "./maintenance.vue"
import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"

@Component({
	components:{Repair, Maintenance}
})
export default class PatientStatistics extends AbpBase{


}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/devices/index.vue